module.exports = __webpack_public_path__ + "assets/images/bg_a7eb1a399fa1aa5e30f3e411635c3911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packs/bg.png
// module id = 62
// module chunks = 0